/**
 * The Cases list's default sort: newest first, by when each case was opened.
 *
 * One object for the three places that must agree: the store's initial state
 * (stores/casesPage.ts), the matching entry on the page's Sort All By menu
 * (cynqueModules/listPageTopButtonBarSelectValues/case.ts), and the one-time
 * migration of the old default (persistence.ts).
 */
export const CASES_PAGE_DEFAULT_SORT = {
  name: 'Opened Date',
  sortKey: 'openedAt',
  descending: true,
}

/**
 * The default this replaced, exactly as the store wrote it -- Case ID with NO
 * `descending`, so oldest first. No menu entry is shaped like this (each one
 * spells its direction), so a persisted sort that equals it was never chosen
 * by anyone.
 */
export const LEGACY_CASES_PAGE_DEFAULT_SORT = {
  name: 'Case ID',
  sortKey: 'hrid',
}
